export default [
  {
    path: '/bulk_certificates',
    name: 'bulkCertificates',
    component: () => import('@/views/modules/bulk_certificates/bulk_certificates.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'certificates',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-bulkCertificate',
    name: 'add_bulkCertificate',
    component: () => import('@/views/modules/bulk_certificates/EditBulkCertificate.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'certificates',
          to: '/bulk_certificates'
        },
        {
          text: 'Add Certificate',
          active: true,
        },
      ],
    },
  },
  {
    path: '/show-bulkCertificate/:id',
    name: 'show_bulkCertificate',
    component: () => import('@/views/modules/bulk_certificates/ShowBulkCertificate.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'certificates',
          to: '/bulk_certificates'
        },
        {
          text: 'show_bread',
          active: true,
        },
      ],
    },
  },
  {
    path: '/edit-bulkCertificate/:id',
    name: 'edit_bulkCertificate',
    component: () => import('@/views/modules/bulk_certificates/EditBulkCertificate.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'certificates',
          to: '/bulk_certificates'
        },
        {
          text: 'edit_bread',
          active: true,
        },
      ],
    },
  },
  
]
